<template>
  <v-dropdown
    class="c-navbar-language"
    :aria-label="$t('accessibility.language')"
  >
    <template #activator>
      {{ subscriber.currentLanguage }}
    </template>
    <router-link
      v-for="lang in info.languages"
      :key="lang"
      :to="`/deeplink/action/CHANGE_LANGUAGE/${lang}`"
      class="o-typography--action"
    >
      {{ lang }}
    </router-link>
  </v-dropdown>
</template>

<script>
  import { VDropdown } from '@/index/shared/components';
  import { EventType } from '@/shared/enums';

  export default {
    components: {
      VDropdown,
    },
    data() {
      return {
        info: this.$services.resolve('info'),
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    mounted() {
      this.$EventBus.on(EventType.CHANGE_LANGUAGE, this.changeLanguage);
    },
    beforeDestroy() {
      this.$EventBus.off(EventType.CHANGE_LANGUAGE, this.changeLanguage);
    },
    methods: {
      changeLanguage(lang) {
        if (!lang) {
          return;
        }

        this.subscriber.changeLanguage(lang);
      },
    },
  };
</script>
